// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
//import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCJzUK-SV1GJbuS36p6YQaEfZpVyOTW1dM",
  authDomain: "newdtp-live.firebaseapp.com",
  projectId: "newdtp-live",
  storageBucket: "newdtp-live.firebasestorage.app",
  messagingSenderId: "249196926749",
  appId: "1:249196926749:web:79e1da8c9679ec55d573f4",
  measurementId: "G-CG9V9TSTBV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);
export const auth = getAuth(app);